// extracted by mini-css-extract-plugin
export default {"cardsContainer":"App_cardsContainer__mgfpz"};